var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{staticClass:"help",attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"v-btn--icon",attrs:{"slot":"activator","dark":"","flat":"","id":"help-menu"},slot:"activator"},[_c('v-icon',[_vm._v("help")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.openDocument()}}},[_c('v-list-tile-content',[_vm._v("Help")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff0f72cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpControls.vue
// module id = 618
// module chunks = 0